/*eslint-disable */

import {
  bus
} from '@/main';
import callingRingtone from '@/assets/audio/videocall_ringtone.mp3';
import commonSocket from "@/services/commonSocket/index.js";

var autoCallDisconnet;
const $ = window.jQuery = require('jquery');
export default {
  name: 'video-call-notification-popup',
  components: {},
  props: ['callerInfo', 'roomId'],
  data () {
    return {
      roomIdForVideoCall:'',
      interClearVal:false,
      selfUserId:'',
      audioPlayer:null
    }
  },
  computed: {

  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    autoCallDisconnet = setInterval(() => {
      this.callNotAnsweredFun();
      this.interClearVal = true;
      if(this.interClearVal == true){
        clearInterval(autoCallDisconnet);
      }
    }, 30000);
    this.playSound(callingRingtone);
  },
  methods: {
    playSound (sound) {
      if(sound) {
        this.audioPlayer = new Audio(sound);
        this.audioPlayer.play();
      }
    },
    stopSound () {
      if(this.audioPlayer == null) return; 
      this.audioPlayer.muted = true;
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer = null
    },
    callAcceptMethod(){
      this.stopSound();
      this.$store.dispatch('videoRoomIdGeneratedMethod', {user:this.roomId}).then((res)=>{
        this.roomIdForVideoCall = res.data.data.id
        commonSocket.emit({
          type: "videoCallAccepted",
          targetId:this.callerInfo.callerID,
          roomId:this.roomIdForVideoCall
        });
        bus.$emit('callerNotifiactionBus', false);
        this.$router.push('/video/conference/#' + this.roomIdForVideoCall);
        clearInterval(autoCallDisconnet)
        document.body.classList.remove('videoNotificationPopup');
      }).catch((err)=>{
      })
    },
    callDeclinedMethod(){
      this.stopSound();
      commonSocket.emit({
        type: "videoCallDecline",
        targetId:this.callerInfo.callerID,
        callerID:this.callerInfo.targetId,
      });
      clearInterval(autoCallDisconnet)
      bus.$emit('callerNotifiactionBus', false);
      document.body.classList.remove('videoNotificationPopup');
    },
    callNotAnsweredFun(){
      this.stopSound();
      commonSocket.emit({
        message: `Call Not recieved.`,
        type: "videoCallNotReceived",
        chatRoomId:this.roomId,
        targetId:this.callerInfo.callerID,
        callerID:this.callerInfo.targetId
      });
      bus.$emit('callerNotifiactionBus', false);
      document.body.classList.remove('videoNotificationPopup');
    }
  }
}